<template>
  <div class="industy-block">
    <div class="fold-btn"
         @click="foldBtn">{{foldBtnContent}}</div>

    <div class="top-charts">
      <div class="mark-line">
        <canvas class="mk"
                :id='"markLine"+type.type'
                width="600"
                height="300"></canvas>
      </div>
      <div class="chart-tag">
        <div class="chart-title-tag"
             :class="[chartType === 'capital' ? 'selected':'']"
             @click="changeType('capital')">市值</div>
        <div class="chart-title-tag"
             :class="[chartType === 'inflow' ? 'selected':'']"
             @click="changeType('inflow')">流入净额</div>
      </div>
      <div class="chart">
        <chart ref="chart1"
               :opt="opt1"></chart>
      </div>
      <div class="chart">
        <chart ref="chart2"
               :opt="opt2"></chart>
      </div>
    </div>

    <!-- <div class="top-charts" v-else>
        <div class="mark-line">
          <canvas  class="mk" :id='"markLine2"+type.type'  width="600" height="300"></canvas>
        </div>
        <div class="chart-title">流入金额</div>
        <div class="chart">
          <chart ref="chartInflow1" :opt="optInflow1"></chart>
        </div>
        <div class="chart">
          <chart ref="chartInflow2" :opt="optInflow2"></chart>
        </div>
      </div> -->

    <hqtable ref="hqtable"
             class="table"
             :data="tdata"
             :thead="thead"
             :fixed="fixed"
             :subset="subset"
             :sort.sync="sort"
             :codeKey="codeKey"
             @on-row-click="rowClick"
             @on-th-click="target">
      <div style="width:100%; padding:100px 0;text-align: center;"
           slot="nodata">{{tableTips}}</div>
      <template v-slot:extend="extend">
        <div slot="extend"
             style="display:table-row-group; vertical-algin:middle; border-color:inherit">
          <div class="hq_tr"
               v-if="total"
               @click="clickOther(999992)"
               v-bind:class="[ selectedCode-0 === 999992?'hq_tr_active':'']">
            <div :td-key="thead[0]['key']"
                 :style="{width:extend.widths[0]+'px'}"
                 class="td-word"
                 @dblclick="jumptoALl()">合计</div>
            <div :td-key="thead[1]['key']"
                 :style="{width:extend.widths[1]+'px'}"
                 class="td-word"
                 @dblclick="jumptoALl()">{{total.industry_code}}</div>
            <div :td-key="thead[2]['key']"
                 :style="{width:extend.widths[2]+'px'}">
              <span :class="[total.week_price_change_ratio > 0 ? 'red' : 'green']">{{Number(total.week_price_change_ratio * 100).toFixed(2)}}%</span>
            </div>
            <div :td-key="thead[3]['key']"
                 :style="{width:extend.widths[3]+'px'}">{{total.hold_amount}}</div>
            <div :td-key="thead[4]['key']"
                 :style="{width:extend.widths[4]+'px'}">{{Number(total.accumulated_net_inflow / 100000000).toFixed(2) }}亿</div>
            <div :td-key="thead[5]['key']"
                 :style="{width:extend.widths[5]+'px'}">{{Number(total.share_market_capital / 100000000).toFixed(2)}}亿</div>
            <div :td-key="thead[6]['key']"
                 :style="{width:extend.widths[6]+'px'}">
              <span :class="[total.accumulated_profit_loss > 0 ? 'red' : 'green']">{{Number(total.accumulated_profit_loss * 100).toFixed(2)}}%</span>
            </div>
            <div :td-key="thead[7]['key']"
                 :style="{width:extend.widths[7]+'px'}">
              <span :class="[total.week_net_inflow > 0 ? 'red' : 'green']">{{Number(total.week_net_inflow / 100000000).toFixed(2)}}亿</span>
            </div>
            <div :td-key="thead[8]['key']"
                 :style="{width:extend.widths[8]+'px'}">
              <span :class="[total.week_share_market_capital > 0 ? 'red' : 'green']">{{Number(total.week_share_market_capital / 100000000).toFixed(2)}}亿</span>
            </div>

          </div>
        </div>
      </template>
    </hqtable>

    <div class="bottom-chart">
      <div class="chart-title">“{{selectName}}” {{typename}}累计流入净额、期末持股市值对比图</div>
      <chart ref="chartCompare"
             :opt="chartCompare"></chart>
    </div>
  </div>
</template>

<script>
import Chart from '../../lib/echarts-middleware';
import Hqtable from '../../lib/v-hqtable';

export default {
  name: 'industryblock',
  props: ['type', 'date', 'resize', 'color', 'resizeType', 'config'],
  components: {
    Chart,
    Hqtable
  },
  created() {
    // this.getDate();
    this.optCapital1.color = this.color.color;
    this.optCapital2.color = this.color.color;
    this.optInflow1.color = this.color.color;
    this.optInflow2.color = this.color.color;
    this.optCapital1.series[0].label.color = this.color.label;
    this.optCapital2.series[0].label.color = this.color.label;
    this.optInflow1.series[0].label.color = this.color.label;
    this.optInflow2.series[0].label.color = this.color.label;
    this.optCapital1.series[0].labelLine.lineStyle.color = this.color.labelLine;
    this.optCapital2.series[0].labelLine.lineStyle.color = this.color.labelLine;
    this.optInflow1.series[0].labelLine.lineStyle.color = this.color.labelLine;
    this.optInflow2.series[0].labelLine.lineStyle.color = this.color.labelLine;
  },
  mounted() {},
  data() {
    return {
      // 表格的属性
      sort: { key: 'share_market_capital', type: 'down' },
      subset: true,
      thead: [
        {
          key: 'industry_name',
          name: '行业',
          width: 110,
          class: ['t-head', 'td-head', 'td_name'],
          events: {
            dblclick: (e, data) => {
              if (data.industry_code && data.industry_code !== 999991 && data.industry_code !== 99992 && data.industry_code !== '--') {
                if (this.type.type - 0 === 1) {
                  TA.log({ id: 'cgpz_lgt_hytj_41', _sid: 'cgpz_lgt_hytj_41' });
                } else {
                  TA.log({ id: 'cgpz_ggt_hytj_41', _sid: 'cgpz_ggt_hytj_41' });
                }

                API.use({
                  method: 'Quote.switchPage',
                  data: {
                    id: '65',
                    code: data.industry_code
                  }
                });
              }
            }
          },
          format: function(v, tr) {
            let icon = '';
            if (!tr.isSub && tr.subset && tr.subset.length && tr.subState) {
              icon = "<span class='icon-sub'>- </span>";
            } else if (!tr.isSub && tr.subset && tr.subset.length && !tr.subState) {
              icon = "<span class='icon-sub'>+ </span> ";
            } else {
              icon = '';
            }
            return '<div class="ta-left txt-hide" title="'+v+'">' + icon + v + "</div>";
          }
        },
        {
          key: 'industry_code',
          name: '代码',
          class: ['t-head', 'td-head', 'td_industry_code'],
          width: 55,
          events: {
            dblclick: (e, data) => {
              if (data.industry_code && data.industry_code !== 999991 && data.industry_code !== 99992 && data.industry_code !== '--') {
                if (this.type.type - 0 === 1) {
                  TA.log({ id: 'cgpz_lgt_hytj_41', _sid: 'cgpz_lgt_hytj_41' });
                } else {
                  TA.log({ id: 'cgpz_ggt_hytj_41', _sid: 'cgpz_ggt_hytj_41' });
                }
                API.use({
                  method: 'Quote.switchPage',
                  data: {
                    id: '65',
                    code: data.industry_code
                  }
                });
              }
            }
          },
          format: function(v) {
            return v ? v : '--';
          }
        },
        {
          key: 'week_price_change_ratio',
          name: '周涨幅',
          sort: true,
          width: 65,
          class: ['t-head', 'td_week_price_change_ratio'],
          format: function(v) {
            let val = v ? (v * 100).toFixed(2) + '%' : '--';
            if (val === '--') {
              return '--';
            }
            if (val - 0 === 0) {
              return '0.00';
            }
            if (v > 0) {
              return '<span class="red">' + val + '</span>';
            } else {
              return '<span class="green">' + val + '</span>';
            }
          }
        },
        {
          key: 'hold_amount',
          name: '持股个数',
          width: 80,
          sort: true,
          class: ['t-head', 'td_hold_amount'],
          format: function(v) {
            return v ? Number(v) : '--';
          }
        },
        {
          key: 'accumulated_net_inflow',
          name: '累计流入净额',
          sort: true,
          width: 120,
          class: ['t-head', 'td_accumulated_net_inflow'],
          format: function(v) {
            return v ? Number(v / 100000000).toFixed(2) + '亿' : '--';
          }
        },

        {
          key: 'share_market_capital',
          name: '期末持股市值',
          sort: true,
          width: 110,
          class: ['t-head', 'td_share_market_capital'],
          format: function(v) {
            return v ? Number(v / 100000000).toFixed(2) + '亿' : '--';
          }
        },
        {
          key: 'accumulated_profit_loss',
          name: '累计持仓盈亏',
          sort: true,
          width: 110,
          class: ['t-head', 'td_accumulated_profit_loss'],
          format: function(v) {
            let val = v ? Number(v * 100).toFixed(2) + '%' : '--';
            if (val === '--') {
              return '--';
            }
            if (val - 0 === 0) {
              return '0.00';
            }
            if (v > 0) {
              return '<span class="red">' + val + '</span>';
            } else {
              return '<span class="green">' + val + '</span>';
            }
          }
        },
        {
          key: 'week_net_inflow',
          name: '本周净买入',
          sort: true,
          width: 100,
          class: ['t-head', 'td_week_net_inflow'],
          format: function(v) {
            let val = v ? Number(v / 100000000).toFixed(2) + '亿' : '--';
            if (val === '--') {
              return '--';
            }
            if (val - 0 === 0) {
              return '0.00';
            }
            if (v > 0) {
              return '<span class="red">' + val + '</span>';
            } else {
              return '<span class="green">' + val + '</span>';
            }
          }
        },
        {
          key: 'week_share_market_capital',
          name: '本周市值增减',
          sort: true,
          width: 110,
          class: ['t-head', 'td_week_share_market_capital'],
          format: function(v) {
            let val = v ? Number(v / 100000000).toFixed(2) + '亿' : '--';
            if (val === '--') {
              return '--';
            }
            if (val - 0 === 0) {
              return '0.00';
            }
            if (v > 0) {
              return '<span class="red">' + val + '</span>';
            } else {
              return '<span class="green">' + val + '</span>';
            }
          }
        }
      ],
      codeKey: 'search_code',
      tdata: [],
      fixed: {
        thead: true,
        theadHeight: 30
      },
      // 图表配置
      // 实例
      getchart: false,
      chart1: {},
      chart2: {},
      opt1: {},
      opt2: {},
      chartCompare: {},
      chartType: 'capital',
      // 配置
      optCapital1: {
        animation: false,
        series: [
          {
            name: '市值',
            type: 'pie',
            selectedOffset: 5,
            radius: ['50', '70'],
            center: ['50%', '50%'],
            startAngle: 0,
            label: {
              formatter: p => {
                return p.name + ':' + Number(p.percent).toFixed(2) + '%';
              }
            },
            labelLine: {
              lineStyle: {}
            },
            data: '',
            emphasis: {}
            // itemStyle: {
            //   emphasis: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)"
            //   }
            // }
          }
        ]
      },
      optCapital2: {
        animation: false,
        series: [
          {
            name: '市值',
            type: 'pie',
            selectedOffset: 5,
            radius: ['50', '70'],
            center: ['50%', '50%'],
            data: '',
            label: {
              formatter: p => {
                return p.name + ':' + Number(p.percent).toFixed(2) + '%';
              }
            },
            labelLine: {
              lineStyle: {}
            },
            emphasis: {}
            // itemStyle: {
            //   emphasis: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: "rgba(0, 0, 0, 0.5)"
            //   }
            // }
          }
        ]
      },
      optInflow1: {
        animation: false,
        series: [
          {
            name: '流入金额',
            type: 'pie',
            selectedOffset: 5,
            startAngle: 0,
            radius: ['50', '70'],
            center: ['50%', '50%'],
            data: '',
            label: {
              formatter: p => {
                return p.name + ':' + Number(p.percent).toFixed(2) + '%';
              }
            },
            labelLine: {
              lineStyle: {}
            },
            emphasis: {}
            // itemStyle: {
            //   emphasis: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
            //   }
            // }
          }
        ]
      },
      optInflow2: {
        animation: false,
        series: [
          {
            name: '流入金额',
            type: 'pie',
            selectedOffset: 5,
            radius: ['50', '70'],
            center: ['50%', '50%'],

            data: '',
            label: {
              formatter: p => {
                return p.name + ':' + Number(p.percent).toFixed(2) + '%';
              }
            },
            labelLine: {
              lineStyle: {}
            },
            emphasis: {}
            // itemStyle: {
            //   emphasis: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
            //   }
            // }
          }
        ]
      },
      optCompare: {
        grid: {
          bottom: 100
        },
        color: ['#f8b551', '#e74741'],
        legend: {
          bottom: 50,
          itemWidth: 10,
          itemHeight: 10,
          data: [{ name: '流入净额', icon: 'rect' }, { name: '市值', icon: 'rect' }],
          textStyle: {
            color: '#626262'
          }
        },
        dataZoom: [
          {
            type: 'inside',
            start: 20,
            end: 100,
            zoomOnMouseWheel: false
          },
          {
            show: true,
            start: 20,
            end: 100,
            height: 25,
            dataBackgroundColor: '#363636'
          }
        ],
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: '#626262'
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          name: '金额(亿)',
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#626262'
            }
          },
          splitLine: {
            show: false
          },

          axisLabel: {
            formatter: value => {
              return parseInt(value / 100000000);
            },
            textStyle: {
              decoration: 'none',
              align: 'right'
            },
            interval: 'auto',
            margin: 3
          }
        },
        tooltip: {
          trigger: 'axis',

          axisPointer: {
            // type: "cross",
            label: {
              show: false
            },
            crossStyle: {
              type: 'solid'
            }
          },
          formatter: params => {
            this.tooltipTarget();
            // if (this.tooltipTargetFn) {
            //   this.tooltipTargetFn();
            // } else {
            //   this.tooltipTargetFn = window.$util.util.throttle(
            //     this.tooltipTarget,
            //     1000
            //   );
            // }
            let time = '时间：' + params[0].name + '<br/>';
            let result = '';
            for (let [index, value] of params.entries()) {
              result += `${value.seriesName}：${parseInt(params[index].value / 100000000)}亿<br/>`;
            }
            return time + result;
          }
        },
        series: [
          {
            data: [],
            type: 'line',
            name: '流入净额',
            showSymbol: false,
            smooth: true
          },
          {
            data: [],
            type: 'line',
            name: '市值',
            showSymbol: false,
            smooth: true
          }
        ]
      },
      selectedAngel1: 0,
      selectedAngel2: 0,
      markLine: '',
      capitalAll: 0,
      inflowAll: 0,
      other1Code: [],
      other2Code: [],
      // 整体配置
      datafault: false,
      allDate: {},
      partDate: {},
      selectedCode: '',
      selectName: '',
      foldAll: false,
      total: '',
      other: '',
      selectedCode1: '',
      selectedCode2: '',
      //埋点
      tooltipTargetFn: '',
      chartCompareDatazoomFn: '',
      chart1MouseoverFn: '',
      chart2MouseoverFn: ''
    };
  },
  methods: {
    getDate() {
      let url = '//zx.10jqka.com.cn/offshorefunds/holdconfiguration/industry';

      $.ajax({
        type: 'GET',
        url: url,
        data: {
          date: this.date,
          type: this.type.type
        },
        dataType: this.$project.getDataType(url),
        xhrFields: {
          withCredentials: true
        },
        success: data => {
          if (data.error_code) {
            console.log(data.error_msg);
          }
          if (data.result.length) {
            this.setTableDate(data.result);
            this.setChartDate();
            this.datafault = false;
            this.selectedCode = '';
            this.selectedCode1 = '';
            this.selectedCode2 = '';
          } else {
            this.datafault = true;
          }
        },
        error: function(e) {
          console.log(e);
        }
      });
    },
    getchartsInstance() {
      this.chart1 = this.$refs['chart1'].chart;
      this.chart2 = this.$refs['chart2'].chart;
      this.chartCompare = this.$refs['chartCompare'].chart;
      this.markLine = document.getElementById('markLine' + this.type.type).getContext('2d');
      this.chart1.on('click', params => {
        if (params.componentType === 'series') {
          let name = params.name;
          this.selectedCode1 = this.allDate[name].search_code;
          if (this.type.type - 0 === 1) {
            if (this.chartType === 'capital') {
              TA.log({ id: 'cgpz_lgt_hytj_30_1', _sid: 'cgpz_lgt_hytj_30_1' });
            } else {
              TA.log({ id: 'cgpz_lgt_hytj_31_1', _sid: 'cgpz_lgt_hytj_31_1' });
            }
          } else {
            if (this.chartType === ' ') {
              TA.log({ id: 'cgpz_ggt_hytj_30_1', _sid: 'cgpz_ggt_hytj_30_1' });
            } else {
              TA.log({ id: 'cgpz_ggt_hytj_31_1', _sid: 'cgpz_ggt_hytj_31_1' });
            }
          }
        }
      });
      this.chart1.on('mouseover', params => {
        if (params.componentType === 'series') {
          if (this.chart1MouseoverFn) {
            this.chart1MouseoverFn();
          } else {
            this.chart1MouseoverFn = window.$util.util.throttle(this.chart1Mouseover, 1000);
          }
        }
      });
      this.chart2.on('click', params => {
        if (params.componentType === 'series') {
          let name = params.name;
          this.selectedCode2 = this.partDate[name].search_code;
          if (this.type.type - 0 === 1) {
            if (this.chartType === 'capital') {
              TA.log({ id: 'cgpz_lgt_hytj_30_3', _sid: 'cgpz_lgt_hytj_30_3' });
            } else {
              TA.log({ id: 'cgpz_lgt_hytj_31_3', _sid: 'cgpz_lgt_hytj_31_3' });
            }
          } else {
            if (this.chartType === 'capital') {
              TA.log({ id: 'cgpz_ggt_hytj_30_3', _sid: 'cgpz_ggt_hytj_30_3' });
            } else {
              TA.log({ id: 'cgpz_ggt_hytj_31_3', _sid: 'cgpz_ggt_hytj_31_3' });
            }
          }
        }
      });
      this.chart2.on('mouseover', params => {
        if (params.componentType === 'series') {
          if (this.chart2MouseoverFn) {
            this.chart2MouseoverFn();
          } else {
            this.chart2MouseoverFn = window.$util.util.throttle(this.chart2Mouseover, 1000);
          }
        }
      });
      this.chartCompare.on('datazoom', () => {
        if (this.chartCompareDatazoomFn) {
          this.chartCompareDatazoomFn();
        } else {
          this.chartCompareDatazoomFn = window.$util.util.throttle(this.chartCompareDatazoom, 1000);
        }
      });
      this.getchart = true;
    },
    getCompareDate() {
      let url = '//zx.10jqka.com.cn/offshorefunds/holdconfiguration/historyindustry';

      $.ajax({
        type: 'GET',
        url: url,
        data: {
          code: this.selectedCode,
          type: this.type.type
        },
        dataType: this.$project.getDataType(url),
        xhrFields: {
          withCredentials: true
        },
        success: data => {
          if (data.error_code) {
            console.log(data.error_msg);
          }
          let dataList = data.result;
          // 该项目功能数据全部暂停更新；后续产品侧重构或下线！！
          if(this.config.switchChangeTime) {
            dataList = dataList.filter(item=>new Date(item.date) < new Date(this.config.stopDate));
          }
          if (dataList.length) {
            this.setCompareDate(dataList);
          }
        },
        error: function(e) {
          console.log(e);
        }
      });
    },
    setTableDate(d) {
      this.tdata = [];
      let arr = Object.keys(d);
      for (let i = 0; i < d.length; i++) {
        if (d[i].search_code - 0 === 999992) {
          this.total = d[i];
        } else if (d[i].search_code - 0 === 999991) {
          this.other = d[i];
        } else {
          d[i].subset = d[i].child;
          this.tdata.push(d[i]);
        }
      }
      this.tdata[0].subState = true;
      // this.selectedCode2 = this.tdata[0].subset[0].search_code;
    },
    setChartDate() {
      let data = this.tdata;
      let capital = [];
      let inflow = [];
      let name1 = [];
      let name2 = [];
      this.allDate = {
        其他: { search_code: 999991 }
      };
      this.partDate = {};
      this.capitalAll = 0;
      this.inflowAll = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i].share_market_capital) {
          this.capitalAll += data[i].share_market_capital - 0;
        }
        if (data[i].accumulated_net_inflow) {
          this.inflowAll += data[i].accumulated_net_inflow - 0;
        }
        if (data[i].search_code) {
          this.allDate[data[i].search_code] = data[i];
        }
        if (data[i].industry_name) {
          this.allDate[data[i].industry_name] = data[i];
        }
        if (data[i].child) {
          let childs = data[i].child;
          for (let item in childs) {
            if (childs[item].search_code) {
              this.partDate[childs[item].search_code] = childs[item];
            }
            if (childs[item].industry_name) {
              this.partDate[childs[item].industry_name] = childs[item];
            }
          }
        }
      }
      this.other1Code = [];
      this.other2Code = [];
      let other1 = {
        name: '其他',
        value: 0
      };
      let other2 = {
        name: '其他',
        value: 0
      };
      for (let i = 0; i < data.length; i++) {
        if (data[i].share_market_capital && data[i].share_market_capital - this.total.share_market_capital / 100 >= 0) {
          let obj = {};
          obj.name = data[i].industry_name;
          obj.value = data[i].share_market_capital;
          if (obj.value < (this.capitalAll / 100) * 5) {
            obj.label = {
              show: false
            };
            obj.labelLine = {
              show: false
            };
            obj.emphasis = {
              label: { show: true },
              labelLine: { show: true }
            };
          }
          capital.push(obj);
        } else {
          this.other1Code.push(data[i].search_code);
          other1.value += data[i].share_market_capital - 0;
        }
        if (data[i].accumulated_net_inflow && data[i].accumulated_net_inflow - this.total.accumulated_net_inflow / 100 >= 0) {
          let obj = {};
          obj.name = data[i].industry_name;
          obj.value = data[i].accumulated_net_inflow;
          if (obj.value < (this.inflowAll / 100) * 5) {
            obj.label = {
              show: false
            };
            obj.labelLine = {
              show: false
            };
            obj.emphasis = {
              label: { show: true },
              labelLine: { show: true }
            };
          }
          inflow.push(obj);
        } else {
          this.other2Code.push(data[i].search_code);
          other2.value += data[i].share_market_capital - 0;
        }
      }
      if (other1.value) {
        if (other1.value < (this.capitalAll / 100) * 5) {
          other1.label = {
            show: false
          };
          other1.labelLine = {
            show: false
          };
          other1.emphasis = {
            label: { show: true },
            labelLine: { show: true }
          };
        }
        capital.push(other1);
      }
      if (other2.value) {
        if (other2.value < (this.inflowAll / 100) * 5) {
          other2.label = {
            show: false
          };
          other2.labelLine = {
            show: false
          };
          other2.emphasis = {
            label: { show: true },
            labelLine: { show: true }
          };
        }
        inflow.push(other2);
      }
      this.optCapital1.series[0].data = capital;
      this.optInflow1.series[0].data = inflow;
      if (!this.getchart) {
        this.getchartsInstance();
      }
      setTimeout(() => {
        this.selectedCode1 = this.tdata[0].search_code;
      }, 1000);
      setTimeout(() => {
        this.selectedCode2 = this.tdata[0].subset[0].search_code;
      }, 1500);
    },
    setChart2Date(parent) {
      let data = this.allDate[parent].subset;
      let capital = [];
      let inflow = [];
      let name = [];
      let capitalAll = 0;
      let inflowAll = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i].share_market_capital) {
          let obj = {};
          obj.name = data[i].industry_name;
          obj.value = data[i].share_market_capital;
          capital.push(obj);
          capitalAll += data[i].share_market_capital - 0;
        }
        if (data[i].accumulated_net_inflow) {
          let obj = {};
          obj.name = data[i].industry_name;
          obj.value = data[i].accumulated_net_inflow;
          inflow.push(obj);
          inflowAll += data[i].accumulated_net_inflow - 0;
        }
      }

      this.optCapital2.series[0].data = capital;
      this.optInflow2.series[0].data = inflow;

      if (this.chartType === 'capital') {
        this.chart2.setOption(this.optCapital2);
      } else {
        this.chart2.setOption(this.optInflow2);
      }
    },
    setChart2DateOther(d1, d2) {
      if (d1 && d1.length > 0) {
        let capital = [];
        let capitalAll = 0;
        for (let i = 0; i < d1.length; i++) {
          if (d1[i].share_market_capital) {
            let obj = {};
            obj.name = d1[i].industry_name;
            obj.value = d1[i].share_market_capital;
            capital.push(obj);
            capitalAll += d1[i].share_market_capital - 0;
          }
        }
        for (let i = 0; i < d1.length; i++) {
          if (capital[i].value < (capitalAll / 100) * 5) {
            capital[i].label = {
              show: false
            };
            capital[i].labelLine = {
              show: false
            };
            capital[i].emphasis = {
              label: { show: true },
              labelLine: { show: true }
            };
          }
        }
        this.optCapital2.series[0].data = capital;
      }
      if (d2 && d2.length > 0) {
        let inflow = [];
        let inflowAll = 0;
        for (let i = 0; i < d2.length; i++) {
          if (d2[i].accumulated_net_inflow) {
            let obj = {};
            obj.name = d2[i].industry_name;
            obj.value = d2[i].accumulated_net_inflow;
            inflow.push(obj);
            inflowAll += d2[i].accumulated_net_inflow - 0;
          }
        }
        for (let i = 0; i < d2.length; i++) {
          if (inflow[i].value < (inflowAll / 100) * 5) {
            inflow[i].label = {
              show: false
            };
            inflow[i].labelLine = {
              show: false
            };
            inflow[i].emphasis = {
              label: { show: true },
              labelLine: { show: true }
            };
          }
        }
        this.optInflow2.series[0].data = inflow;
      }
      if (this.chartType === 'capital') {
        this.chart2.setOption(this.optCapital2);
      } else {
        this.chart2.setOption(this.optInflow2);
      }
    },
    setCompareDate(d) {
      let time = [];
      let inflow = [];
      let capital = [];
      for (let i = 0; i < d.length; i++) {
        if (d[i].accumulated_net_inflow && d[i].share_market_capital) {
          let date = d[i].date.split('-').join('');
          time.push(date);
          inflow.push(d[i].accumulated_net_inflow - 0);
          capital.push(d[i].share_market_capital - 0);
        }
      }
      this.optCompare.xAxis.data = time;
      this.optCompare.series[0].data = inflow;
      this.optCompare.series[1].data = capital;
      this.chartCompare.setOption(this.optCompare);
    },
    rowClick(e, data, target) {
      if (e.target.tagName === 'SPAN' && e.target.className === 'icon-sub') {
        this.$refs.hqtable.setSubState(target.getAttribute('idx'));
        if (this.type.type - 0 === 1) {
          if (data.subState) {
            TA.log({ id: 'cgpz_lgt_hytj_43', _sid: 'cgpz_lgt_hytj_43' });
          } else {
            TA.log({ id: 'cgpz_lgt_hytj_44', _sid: 'cgpz_lgt_hytj_44' });
          }
        } else {
          if (data.subState) {
            TA.log({ id: 'cgpz_ggt_hytj_43', _sid: 'cgpz_ggt_hytj_43' });
          } else {
            TA.log({ id: 'cgpz_ggt_hytj_44', _sid: 'cgpz_ggt_hytj_44' });
          }
        }
      } else {
        if (this.type.type - 0 === 1) {
          TA.log({ id: 'cgpz_lgt_hytj_40', _sid: 'cgpz_lgt_hytj_40' });
        } else {
          TA.log({ id: 'cgpz_ggt_hytj_40', _sid: 'cgpz_ggt_hytj_40' });
        }
        if (!data.isSub) {
          this.$refs.hqtable.setActiveIndex(target.getAttribute('idx'));
          let code = target.getAttribute('idx');
          if (this.other1Code.indexOf(code) >= 0 || this.other2Code.indexOf(code) >= 0) {
            this.selectedCode1 = 999991;
          }
          if (this.selectedCode1 === target.getAttribute('idx') && this.selectedCode1 !== this.selectedCode) {
            this.selectedCode1 = 999992;
          }
          setTimeout(() => {
            this.selectedCode1 = target.getAttribute('idx');
          }, 100);
        } else {
          this.$refs.hqtable.setActiveIndex(target.getAttribute('idx'));
          let pic = data.parent_industry_code;
          if (this.other1Code.indexOf(pic) >= 0 && this.other2Code.indexOf(pic) < 0) {
            this.selectedCode1 = pic;
            let type = 'capital';
            this.randerOther(type);
          } else if (this.other2Code.indexOf(pic) >= 0 && this.other1Code.indexOf(pic) < 0) {
            this.selectedCode1 = pic;
            let type = 'inflow';
            this.randerOther(type);
          } else if (this.other2Code.indexOf(pic) >= 0 && this.other1Code.indexOf(pic) >= 0) {
            this.selectedCode1 = 999991;
          } else {
            this.selectedCode1 = pic;
          }
          setTimeout(() => {
            this.selectedCode2 = target.getAttribute('idx');
          }, 500);
        }
      }
    },
    rechart(val) {
      console.log(val);
      if (!this.getchart) return;
      let w = 0;
      let w1 = 0;
      if (val < 1820) {
        console.log(val);
        w = (val - 137) / 2;
        w1 = val - 142;
      } else {
        w = (val - 137 - 8) / 4;
        w1 = (val - 142 - 5) / 2;
      }
      let opts = {
        width: w
      };
      let opts1 = {
        width: w1
      };
      this.chart1.resize(opts);
      this.chart2.resize(opts);
      this.chartCompare.resize(opts1);
      this.changeSelected1(true);
      this.changeSelected2(true);
      this.drewMarkLine();
      this.$refs.hqtable.resize();
    },
    randerOther(type) {
      if (type === 'capital') {
        let capital = 0;
        let child1 = [];
        for (let i in this.other1Code) {
          capital += this.allDate[this.other1Code[i]].share_market_capital - 0;
          child1 = child1.concat(this.allDate[this.other1Code[i]].subset);
        }
        this.selectedAngel1 = (capital / 2 / this.capitalAll) * 360;
        let capitalAngle = 360 - (capital / 2 / this.capitalAll) * 360;
        this.optCapital1.series[0].startAngle = capitalAngle;

        this.setChart2DateOther(child1, []);
      } else {
        let inflow = 0;
        let child2 = [];
        for (let j in this.other2Code) {
          inflow += this.allDate[this.other2Code[j]].accumulated_net_inflow - 0;
          child2 = child2.concat(this.allDate[this.other2Code[j]].subset);
        }
        this.selectedAngel2 = (inflow / 2 / this.inflowAll) * 360;
        let inflowAngle = 360 - (inflow / 2 / this.inflowAll) * 360;
        this.optInflow1.series[0].startAngle = inflowAngle;
      }
      if (this.chartType === 'capital') {
        this.chart1.setOption(this.optCapital1);
      } else {
        this.chart1.setOption(this.optInflow1);
      }
      this.chart1.dispatchAction({
        type: 'pieSelect',
        name: '其他'
      });
      this.drewMarkLine();
    },
    changeSelected1(bol) {
      let val = this.selectedCode1;
      this.selectedCode2 = '';
      if (val - 0 === 999991) {
        //其他
        let inflow = 0;
        let capital = 0;
        let child1 = [];
        let child2 = [];
        for (let i in this.other1Code) {
          capital += this.allDate[this.other1Code[i]].share_market_capital - 0;
          child1 = child1.concat(this.allDate[this.other1Code[i]].subset);
        }
        for (let j in this.other2Code) {
          inflow += this.allDate[this.other2Code[j]].accumulated_net_inflow - 0;
          child2 = child2.concat(this.allDate[this.other2Code[j]].subset);
        }
        this.selectedAngel1 = (inflow / 2 / this.inflowAll) * 360;
        this.selectedAngel2 = (capital / 2 / this.capitalAll) * 360;
        let inflowAngle = 360 - (inflow / 2 / this.inflowAll) * 360;
        let capitalAngle = 360 - (capital / 2 / this.capitalAll) * 360;
        this.optCapital1.series[0].startAngle = capitalAngle;
        this.optInflow1.series[0].startAngle = inflowAngle;

        if (this.chartType === 'capital') {
          this.chart1.setOption(this.optCapital1);
        } else {
          this.chart1.setOption(this.optInflow1);
        }

        this.drewMarkLine();

        this.chart1.dispatchAction({
          type: 'pieSelect',
          name: '其他'
        });
        this.setChart2DateOther(child1, child2);
        this.$refs.hqtable.setActiveIndex(val);
      } else {
        this.setChart2Date(val);
        // 计算旋转角度
        let lock = false;
        let inflow = 0;
        let capital = 0;
        let inflowStart = 0;
        let capitalStart = 0;
        for (let i in this.tdata) {
          if (this.tdata[i].search_code === val) {
            lock = true;
            inflow = this.tdata[i].accumulated_net_inflow - 0;
            capital = this.tdata[i].share_market_capital - 0;
          }
          if (!lock && this.other1Code.indexOf(this.tdata[i].search_code) < 0) {
            capitalStart += this.tdata[i].share_market_capital - 0;
          }
          if (!lock && this.other2Code.indexOf(this.tdata[i].search_code) < 0) {
            inflowStart += this.tdata[i].accumulated_net_inflow - 0;
          }
        }
        let inflowAngle = ((inflowStart + inflow / 2) / this.inflowAll) * 360;
        let capitalAngle = ((capitalStart + capital / 2) / this.capitalAll) * 360;
        this.selectedAngel1 = (inflow / 2 / this.inflowAll) * 360;
        this.selectedAngel2 = (capital / 2 / this.capitalAll) * 360;
        this.optCapital1.series[0].startAngle = capitalAngle;
        this.optInflow1.series[0].startAngle = inflowAngle;

        if (this.chartType === 'capital') {
          this.chart1.setOption(this.optCapital1);
        } else {
          this.chart1.setOption(this.optInflow1);
        }

        this.drewMarkLine();
        // 选择元素
        let currentName = this.allDate[val].industry_name;

        this.chart1.dispatchAction({
          type: 'pieSelect',
          name: currentName
        });

        if (!bol) {
          this.selectedCode = val;
          this.selectName = currentName;
          this.getCompareDate();
        }
        this.$refs.hqtable.setActiveIndex(val);
      }
    },
    changeSelected2(bol) {
      let val = this.selectedCode2;
      if (!val) return;
      let currentName = this.partDate[val].industry_name;

      this.chart2.dispatchAction({
        type: 'pieSelect',
        name: currentName
      });

      if (!bol) {
        this.selectedCode = val;
        this.selectName = currentName;
        this.$refs.hqtable.setActiveIndex(val);
        this.getCompareDate();
      }
    },
    foldBtn() {
      if (this.type.type - 0 === 1) {
        if (this.foldAll) {
          TA.log({ id: 'cgpz_lgt_hytj_46', _sid: 'cgpz_lgt_hytj_46' });
        } else {
          TA.log({ id: 'cgpz_lgt_hytj_45', _sid: 'cgpz_lgt_hytj_46' });
        }
      } else {
        if (this.foldAll) {
          TA.log({ id: 'cgpz_ggt_hytj_46', _sid: 'cgpz_ggt_hytj_46' });
        } else {
          TA.log({ id: 'cgpz_ggt_hytj_45', _sid: 'cgpz_ggt_hytj_46' });
        }
      }
      for (let i = 0; i < this.tdata.length; i++) {
        this.tdata[i].subState = !this.foldAll;
      }
      this.foldAll = !this.foldAll;
      this.$refs.hqtable.setActiveIndex(this.selectedCode);
    },
    drewMarkLine() {
      this.markLine.clearRect(0, 0, 600, 300);
      this.markLine.strokeStyle = '#868686';
      let x1 = 150 + Math.cos((this.selectedAngel1 / 360) * Math.PI) * 50;
      let y1 = Math.sin((this.selectedAngel1 / 360) * Math.PI) * 50;
      this.markLine.beginPath();
      this.markLine.moveTo(x1, 150 + y1);
      this.markLine.lineTo(440, 230);
      this.markLine.moveTo(x1, 150 - y1);
      this.markLine.lineTo(440, 70);
      this.markLine.stroke();
    },
    clickOther(val) {
      this.selectedCode1 = val;
      this.selectedCode2 = '';
      this.selectedCode = val;
      this.selectName = '全部';
      this.getCompareDate();
      this.$refs.hqtable.setActiveIndex(val);
    },
    changeType(val) {
      if (this.type.type - 0 === 1) {
        if (this.chartType === 'capital') {
          TA.log({ id: 'cgpz_lgt_hytj_31', _sid: 'cgpz_lgt_hytj_31' });
        } else {
          TA.log({ id: 'cgpz_lgt_hytj_30', _sid: 'cgpz_lgt_hytj_30' });
        }
      } else {
        if (this.chartType === 'capital') {
          TA.log({ id: 'cgpz_ggt_hytj_31', _sid: 'cgpz_ggt_hytj_31' });
        } else {
          TA.log({ id: 'cgpz_ggt_hytj_30', _sid: 'cgpz_ggt_hytj_30' });
        }
      }

      if (this.chartType !== val) {
        this.chartType = val;
        this.changeSelected1(true);
        this.changeSelected2(true);
      }
    },
    jumptoALl() {
      if (this.type.type === 1) {
        API.use({
          method: 'Quote.switchPage',
          data: {
            id: '65',
            code: '120:000985'
          }
        });
      } else {
        API.use({
          method: 'Quote.switchPage',
          data: {
            id: '65',
            code: 'HSHKI'
          }
        });
      }
    },
    tooltipTarget() {
      clearTimeout(this.tipTimer);
      this.tipTimer = setTimeout(() => {
        if (this.type.type - 0 === 1) {
          TA.log({ id: 'cgpz_lgt_hytj_50', _sid: 'cgpz_lgt_hytj_50' });
        } else {
          TA.log({ id: 'cgpz_ggt_hytj_50', _sid: 'cgpz_ggt_hytj_50' });
        }
      }, 800);
    },
    target() {
      if (this.type.type - 0 === 1) {
        TA.log({ id: 'cgpz_lgt_hytj_42', _sid: 'cgpz_lgt_hytj_42' });
      } else {
        TA.log({ id: 'cgpz_ggt_hytj_42', _sid: 'cgpz_ggt_hytj_42' });
      }
    },
    chartCompareDatazoom() {
      if (this.type.type - 0 === 1) {
        TA.log({ id: 'cgpz_lgt_hytj_51', _sid: 'cgpz_lgt_hytj_51' });
      } else {
        TA.log({ id: 'cgpz_ggt_hytj_51', _sid: 'cgpz_ggt_hytj_51' });
      }
    },
    chart1Mouseover() {
      if (this.type.type - 0 === 1) {
        if (this.chartType === 'capital') {
          TA.log({ id: 'cgpz_lgt_hytj_30_2', _sid: 'cgpz_lgt_hytj_30_2' });
        } else {
          TA.log({ id: 'cgpz_lgt_hytj_31_2', _sid: 'cgpz_lgt_hytj_31_2' });
        }
      } else {
        if (this.chartType === 'capital') {
          TA.log({ id: 'cgpz_ggt_hytj_30_2', _sid: 'cgpz_ggt_hytj_30_2' });
        } else {
          TA.log({ id: 'cgpz_ggt_hytj_31_2', _sid: 'cgpz_ggt_hytj_31_2' });
        }
      }
    },
    chart2Mouseover() {
      if (this.type.type - 0 === 1) {
        if (this.chartType === 'capital') {
          TA.log({ id: 'cgpz_lgt_hytj_30_4', _sid: 'cgpz_lgt_hytj_30_4' });
        } else {
          TA.log({ id: 'cgpz_lgt_hytj_31_4', _sid: 'cgpz_lgt_hytj_31_4' });
        }
      } else {
        if (this.chartType === 'capital') {
          TA.log({ id: 'cgpz_ggt_hytj_30_4', _sid: 'cgpz_ggt_hytj_30_4' });
        } else {
          TA.log({ id: 'cgpz_ggt_hytj_31_4', _sid: 'cgpz_ggt_hytj_31_4' });
        }
      }
    }
  },
  computed: {
    typename() {
      return this.type.typename;
    },
    foldBtnContent() {
      if (!this.foldAll) {
        return '一键展开二级行业';
      } else {
        return '一键收起二级行业';
      }
    },
    tableTips() {
      if (this.datafault) {
        return '网络开了小差，过会就回来';
      } else {
        return '数据飞速加载中...';
      }
    }
  },
  watch: {
    date: {
      handler(newval, oldval) {
        if (newval) {
            this.getDate();
        }
      },
      immediate: true
    },
    resizeType(val) {
      if (val === 'industry' + this.type.type) {
        console.log(val);
        this.rechart(this.resize);
      }
    },
    selectedCode1(val, old) {
      if (old && old !== 999991 && old !== 999992) {
        let oldName = this.allDate[old].industry_name;
        this.chart1.dispatchAction({
          type: 'pieUnSelect',
          name: oldName
        });
      }
      if (val === this.selectedCode || !val || val - 0 === 999992) return;
      this.changeSelected1(!old);
    },
    selectedCode2(val, old) {
      if (old) {
        let oldName = this.partDate[old].industry_name;
        this.chart2.dispatchAction({
          type: 'pieUnSelect',
          name: oldName
        });
      }

      if (val === old || !val) return;
      this.changeSelected2();
    },
    color() {
      this.optCapital1.color = this.color.color;
      this.optCapital2.color = this.color.color;
      this.optInflow1.color = this.color.color;
      this.optInflow2.color = this.color.color;
      this.optCapital1.series[0].label.color = this.color.label;
      this.optCapital2.series[0].label.color = this.color.label;
      this.optInflow1.series[0].label.color = this.color.label;
      this.optInflow2.series[0].label.color = this.color.label;
      this.optCapital1.series[0].labelLine.lineStyle.color = this.color.labelLine;
      this.optCapital2.series[0].labelLine.lineStyle.color = this.color.labelLine;
      this.optInflow1.series[0].labelLine.lineStyle.color = this.color.labelLine;
      this.optInflow2.series[0].labelLine.lineStyle.color = this.color.labelLine;
    }
  }
};
</script>

<style scoped>
.industy-block {
  position: relative;
}
.fold-btn {
  position: absolute;
  top: -21px;
  right: 10px;
  font-size: 12px;
  /* color: #b3b3b3; */
  cursor: pointer;
}
.fold-btn:hover {
  color: #b40606;
}
.top-charts {
  height: 300px;
  padding: 7px 0 10px;
  display: flex;
  flex-direction: row;
  position: relative;
}

.table {
  widows: 100%;
  height: 400px;
  margin: 0 auto;
  font-size: 12px;
}
.chart {
  /* flex-grow: 1; */
  flex: 1;
  height: 300px;
  /* flex-shrink: 0; */
  min-width: 300px;
}

.chart-tag {
  position: absolute;
  font-size: 14px;
  padding-left: 5px;
  left: 10px;
  top: 5px;
  z-index: 100;
  display: flex;
}
.chart-title {
  position: absolute;
  font-size: 12px;
  padding-left: 5px;
  left: 10px;
  top: 3px;
}
.chart-tag .chart-title-tag {
  border-bottom: 2px solid;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  color: #8c929c;
  padding: 0 10px;
}
.chart-tag .selected {
  color: #ce8263;
}
.bottom-chart {
  height: 300px;
  position: relative;
  margin-top: 20px;
}

.mark-line {
  position: absolute;
  width: 100%;
  height: 300px;
}
.mk {
  width: 100%;
  height: 300px;
}

.table >>> div[thead-key='industry_name'],
.table >>> div[td-key='industry_name'] > div {
  text-align: left;
}
.table >>> div[thead-key='industry_name'],
.table >>> div[td-key='industry_name'] {
  padding-left: 5px;
}
.table >>> div[thead-key='industry_code'],
.table >>> div[td-key='industry_code'] {
  text-align: left;
}
.table >>> .txt-hide{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/block/industryblock.vue